import classNames from "classnames";
import styles from "./styles.module.css";
import { ClickAwayListener } from "@mui/material";
import { AppUnderlinedTitle } from "../../../../shared/components/AppUnderlinedTitle";
import { AppIconButton } from "../../../../shared/components/AppIconButton";
import { BigXIcon } from "../../../../shared/icons/BigXIcon";

interface Props {
  isChatOpen: boolean;
  children: React.ReactNode;
  handleCloseChat: () => void;
  headerContent?: React.ReactNode;
  className?: string;
}

export const ChatDrawer = ({
  isChatOpen,
  children,
  handleCloseChat,
  headerContent,
  className,
}: Props) => {
  return (
    <div
      className={classNames(
        styles["chat-drawer"],
        isChatOpen && styles["chat-drawer-open"],
      )}
    >
      <div className={styles["chat-header"]}>
        <AppUnderlinedTitle leftContent={headerContent ? headerContent : "Чат"}>
          <AppIconButton onClick={handleCloseChat}>
            <BigXIcon />
          </AppIconButton>
        </AppUnderlinedTitle>
      </div>
      {children}
    </div>
  );
};
